(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.BulkDeleteController = (function(superClass) {
    extend(BulkDeleteController, superClass);

    function BulkDeleteController(scope, transitions, state, modalInstance, Data, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.modalInstance = modalInstance;
      this.http = http;
      this.handleMessages = bind(this.handleMessages, this);
      this.confirmDelete = bind(this.confirmDelete, this);
      BulkDeleteController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = 'Confirm Deletion';
      this.scope.multiple = Data.multiple;
      this.scope.delete_array = Data.selected;
      this.scope.confirmDelete = this.confirmDelete;
    }

    BulkDeleteController.prototype.confirmDelete = function() {
      return this.handleMessages(this.http.post('backend/grower/fieldprint/delete', {
        fieldprints: this.scope.delete_array
      }));
    };

    BulkDeleteController.prototype.handleMessages = function(promise) {
      promise.then((function(_this) {
        return function(response) {
          var ref, ref1;
          if (response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) {
            return _this.closeWithAlert(response.data.status);
          }
        };
      })(this));
      return promise;
    };

    return BulkDeleteController;

  })(DialogController);

}).call(this);
